<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div id="information-bidding" class="inner-wrap">
  <ul class="bidding-tab">
    <li class="nav-item"><a class="cp nav-link" [ngClass]="{active: tabIndex==0}" (click)="tabIndex=0">물품</a></li>
    <li class="nav-item"><a class="cp nav-link" [ngClass]="{active: tabIndex==1}" (click)="tabIndex=1">용역</a></li>
  </ul>

  <div class="tab-content">
    <div class="tab-pane" [ngClass]="{show: tabIndex==0, active: tabIndex==0, fadeIn: tabIndex==0, fade: tabIndex!==0}">
      <iframe name="con" id="contentFrame" frameborder="0" border="0" framespacing="0" scrolling="no" marginwidth="0" marginheight="0" width="820px" height="1180px" align="center" src="http://www.g2b.go.kr:8081/ep/preparation/orderplan/orderplanPubList.do?taskClCd=1"></iframe>
    </div>
    <div class="tab-pane" [ngClass]="{show: tabIndex==1, active: tabIndex==1, fadeIn: tabIndex==1, fade: tabIndex!==1}">
      <iframe name="con" id="contentFrame" frameborder="0" border="0" framespacing="0" scrolling="no" marginwidth="0" marginheight="0" width="820px" height="1180px" align="center" src="http://www.g2b.go.kr:8081/ep/preparation/orderplan/orderplanPubList.do?taskClCd=5"></iframe>
    </div>
  </div>
</div>

<app-footer></app-footer>